export default __webpack_public_path__ + "static/media/BasicVideo1.ebb475f6.png";